/* @flow */
// typecheck: ignore file
import React, { Component, PropTypes } from 'react';
import ActivityForm from 'payments/components/ActivityForm.jsx';
import ActivityActions from 'payments/actions/ActivityActions';
import ToastActions from 'actions/ToastActions';
import Activity from 'entities/Activity';
import { pickBy } from 'lodash';

import type { ActivityEditParams } from 'payments/constants/ActivityTypes';

class ActivityFormEditHandler extends Component {
  static propTypes = {
    initialActivity: PropTypes.instanceOf(Activity),
    onEdited: PropTypes.func,
    canCollectMoney: PropTypes.bool,
  };

  state = {
    loading: false,
  }

  difference(updated: any, original: any): any {
    return updated === original ? undefined : updated;
  }

  dateDifference(updated: ?Date, original: ?Date): ?Date {
    if (!updated) {
      return undefined;
    }
    if (!original) {
      return updated;
    }
    return updated.getTime() === original.getTime() ? undefined : updated;
  }

  onValidSubmit = (values: Object) => {
    this.setState({ loading: true });

    const onEdited = (activity) => {
      this.setState({ loading: false });
      if (this.props.onEdited) {
        this.props.onEdited(activity);
      }
    };

    const onError = (error) => {
      this.setState({ loading: false });
      ToastActions.showAPIError(error);
      throw error;
    };

    const original = this.props.initialActivity.toJSON();
    const params: ActivityEditParams = pickBy({
      welcomeMsgBody: this.difference(values.welcome_msg_body, original.welcome_msg_body),
      activity: this.props.initialActivity,
      amountPerPerson: this.difference(
        values.amount || values.amount === 0 ? values.amount * 100 : undefined,
        original.amount_per_person
      ),
      collectOnline: this.difference(values.collect_online, original.collect_online),
      hasChildren: this.difference(values.has_children, original.has_children),
      location: this.difference(values.location, original.location),
      endDate: this.dateDifference(values.end_date, original.end_at),
      title: this.difference(values.title, original.title),
      date: this.dateDifference(values.date, original.start_at),
    }, (v: any): boolean => {
      return v !== undefined && v !== null;
    });

    if (Object.keys(params).length === 1) {
      onEdited(this.props.initialActivity);
      return;
    }

    return ActivityActions
      .edit(params)
      .then(onEdited)
      .catch(onError);
  }

  render() {
    const { initialActivity } = this.props;

    return (
      <ActivityForm
        showLabels
        submitText="Update"
        initialActivity={this.props.initialActivity}
        loading={this.state.loading}
        onValidSubmit={this.onValidSubmit}
        canCollectMoney={this.props.canCollectMoney}
        disabled={initialActivity.getStartAt() < new Date()}
      />
    );
  }
}

export default ActivityFormEditHandler;



// WEBPACK FOOTER //
// ./src/payments/components/ActivityFormEditHandler.jsx